<div class="particle-host" #p5Container>
    <!-- p5 canvas is injected here by the sketch -->
    <!-- Word bubble overlay rendered on top of the p5 canvas -->
    <canvas class="word-overlay"></canvas>
  </div>